module.exports = __webpack_public_path__ + "img/cervical-cancer-leaflet.79b03d0a.jpg";